import React from 'react'
import { checkTextTranslation, getObject, imageAddress, msToHMS } from '../../utils/useful'

class TableVideoInput extends React.Component {
  state = {
  }

  componentDidMount() {
    this.init()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data || this.props.fullData != prevProps.fullData) {
      this.init()
    }
  }

  init() {
    let data = this.props.data
    let output = data
    if (typeof data == 'string' && /\{\{(.*?)\}\}/.test(data)) {
      let reg = new RegExp('\{\{(.*?)\}\}', 'g')
      // console.log("TEST!!")
      let matches = data.match(reg)

      if (matches && matches.length > 0) {
        for (let index = 0; index < matches.length; index++) {
          const match = matches[index];

          // console.log("here!!!")
          let key = match.replace(/{/g, '').replace(/}/g, '')

          // console.log(matches)
          // console.log(key)

          if (this.props.headers) {
            for (let j = 0; j < this.props.headers.length; j++) {
              const header = this.props.headers[j];

              // console.log(header?.key)
              // console.log(header?.type)

              if (((key == header.information?.label || key == header.key || ('values.' + key) == (header.key))) && header.type == 'VideoInput') {
                let value = getObject(this.props.fullData, header.key)
                // console.log(value)
                // let nreg = new RegExp(match, 'g')
                output = value
              }
            }
          }
        }
        if (/\{\{(.*?)\}\}/.test(output)) {
          output = null
        }
      }
    } else if (data == '**custom') {
      output = this.props.header?.information?.address
    }



    this.setState({ data: output })

  }


  changeInputValue(target) {
    let value = (target.validity.valid) ? target.value : null
    if (value !== null) {
      this.props.changeValue(this.props.header.key, value)
    }
  }


  renderImage(image, index, margin, local) {
    // let styleInfo = this.props.styleInfo
    let mimageAddress = imageAddress(image, 'videoCover', null, 'cover')

    let styleInfo = this.props.header.information?.style
    let information = this.props.header.information
    // if (local) {
    //   mimageAddress = imageAddress(null)
    // }

    // console.log(image)
    // console.log(mimageAddress)

    if (styleInfo) {
      return (
        <div className='w-100 position-relative'>
          <img key={index} src={mimageAddress} style={{ width: styleInfo?.width ? (styleInfo?.width + (styleInfo?.widthUnit ?? '%')) : '100%', borderRadius: styleInfo?.borderRadius ?? 10, objectFit: 'cover' }} />
          {information.showDuration && image && (
            <div className='position-absolute br-4 white' style={{ bottom: 10, right: 5, backgroundColor: '#000000ee', padding: '2px 4px' }}>
              <p className='text-smaller text-semibold'>{msToHMS(image?.duration)}</p>
            </div>
          )}

        </div>
      )
    } else {
      return (
        <img key={index} src={mimageAddress} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: margin ? 2 : null }} />
      )
    }
  }



  renderVideo(image, index, margin, local) {
    // let styleInfo = this.props.styleInfo

    // console.log(image)
    let mimageAddress = imageAddress(image, 'videoCover', null, 'cover')
    let mimageVideo = imageAddress(image, 'video', null)

    let information = this.props.header?.information
    let styleInfo = information?.style

    // console.log(mimageVideo)
    // console.log(mimageVideo)


    // if (local) {
    //   mimageAddress = imageAddress(null)
    // }

    // console.log(this.props.fullData)
    // console.log(mimageAddress)

    let aspectRatio
    if (information?.antecedent || information?.consequent) {
      aspectRatio = (Number(information.antecedent) ?? 1) + "/" + (Number(information.consequent) ?? 1)
    }

    // console.log(aspectRatio)
    let objectFit = information?.objectFit ?? 'cover'

    return (
      <>
        {/* {mimageAddress} */}
        {image ? (
          <video id="myImage" width={'100%'} style={{ width: '100%', borderRadius: styleInfo?.borderRadius ?? 10, }} src={this.state.video} key={this.state.video} controls poster={mimageAddress}>
            <source id="mySource" src={mimageVideo} type="video/mp4"></source>
          </video>
        ) : (
          <img src={mimageAddress} style={{ width: styleInfo?.width ? (styleInfo?.width + (styleInfo?.widthUnit ?? '%')) : '100%', borderRadius: styleInfo?.borderRadius ?? 10, objectFit: 'cover' }} />
        )}
      </>
    )

  }


  render() {

    // let header = this.props.header
    // let data = this.state.data
    // console.log(this.state.data)
    let information = this.props.header?.information

    let styleInfo = this.props.header.information?.style
    let justifyContent = styleInfo?.align
    let showCover = information.showCover
    if(this.props.tableCell){
      showCover= true
    }

    return (

      <div className="text-center d-flex  w-100" style={{ overflow: 'auto', justifyContent: justifyContent ?? 'center' }}>
        {/* {Array.isArray(this.state.data) && this.state.data.map((image, index) => {
          // console.log(image)
          return (
            this.renderImage(image, index, true)
            // <img key={index} src={imageAddress(image, "mini", 'mini')} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: 2 }} />
          )
        })
        }

        {!Array.isArray(this.state.data) && this.state.data && (
          this.renderImage(this.state.data)
          // <img src={imageAddress(this.state.data, "mini", "mini")} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover' }} />
        )}

        {!this.state.data && (
          this.renderImage(null, null, null, true)
        )} */}


        {showCover && (
          <div className='w-100'>
            {!Array.isArray(this.state.data) && this.state.data && (
              this.renderImage(this.state.data)
            )}

            {!this.state.data && (
              this.renderImage(null, null, null, true)
            )}
          </div>

        )}


        {!showCover && (
          <div className='w-100'>
            {!Array.isArray(this.state.data) && this.state.data && (
              this.renderVideo(this.state.data)
            )}

            {!this.state.data && (
              this.renderVideo(null, null, null, true)
            )}
          </div>

        )}

      </div>

      // <div className="w-100 h-100">
      //     <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data}</p>
      // </div>
    )
  }
}

export default TableVideoInput;